/* Griptec bundle-tier selector.
   Wires a set of tier radio-rows to Dawn's product-form:
   - sets the form's quantity input to the tier's quantity
   - when a bundle product/variant is chosen, swaps the form's `id` input
     to that variant so the correct product is added to cart
   - keeps the add-to-cart button label, and any sticky ATC popup, in sync.
   Vanilla JS, no dependencies. */
(function () {
  'use strict';

  function initGroup(group) {
    if (group.dataset.griptecTiersInit === 'true') return;
    group.dataset.griptecTiersInit = 'true';

    var sectionId = group.getAttribute('data-section-id');
    var tiers = Array.prototype.slice.call(group.querySelectorAll('.g-tier'));
    if (!tiers.length) return;

    var form = document.getElementById('product-form-' + sectionId);
    var defaultVariantId = group.getAttribute('data-default-variant-id') || '';
    // Tracks the variant chosen in Dawn's variant picker, so tiers without an
    // explicit bundle variant add THAT variant (not the page-load default).
    var currentPickerVariantId = defaultVariantId;

    function formInput(name) {
      if (!form) return null;
      return form.querySelector('[name="' + name + '"]');
    }

    function select(tier) {
      tiers.forEach(function (t) {
        t.classList.remove('is-selected');
        var r = t.querySelector('.g-tier__radio');
        if (r) r.checked = false;
      });
      tier.classList.add('is-selected');
      var radio = tier.querySelector('.g-tier__radio');
      if (radio) radio.checked = true;

      var qty = tier.getAttribute('data-quantity') || '1';
      var explicitId = tier.getAttribute('data-variant-id') || '';
      var variantId = explicitId || currentPickerVariantId || defaultVariantId;
      var name = tier.getAttribute('data-name') || '';
      var price = tier.getAttribute('data-price') || '';
      var save = tier.getAttribute('data-save') || '';

      // Update the form's quantity + variant id inputs so ATC adds the right thing.
      var idInput = formInput('id');
      if (idInput && variantId) idInput.value = variantId;

      var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      if (qtyInput) qtyInput.value = qty;

      // Update the main add-to-cart button label.
      if (form) {
        var submitText = form.querySelector('.product-form__submit span') ||
          form.querySelector('[name="add"] span') ||
          form.querySelector('[name="add"]');
        if (submitText && name) {
          submitText.textContent = 'Add ' + name + (price ? ' — ' + price : '');
        }
      }

      // Broadcast so the sticky ATC popup can mirror the selection.
      document.dispatchEvent(new CustomEvent('griptec:tier-change', {
        detail: {
          sectionId: sectionId,
          name: name,
          price: price,
          save: save,
          quantity: qty,
          variantId: variantId
        }
      }));
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function (e) {
        // let the native radio toggle, but drive selection ourselves
        if (e.target && e.target.tagName === 'A') return;
        select(tier);
      });
      var radio = tier.querySelector('.g-tier__radio');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) select(tier);
        });
      }
    });

    // Initialise from the pre-selected tier (or the first one).
    var initial = group.querySelector('.g-tier.is-selected') || tiers[0];
    if (initial) select(initial);

    // Follow Dawn's variant picker: re-price quantity tiers from their
    // per-variant price map and re-apply the current tier so the form's
    // variant id stays correct (bundle tiers keep their bundle variant,
    // quantity tiers follow the picker).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var d = (evt && evt.data) || {};
        if (d.sectionId && sectionId && String(d.sectionId) !== String(sectionId)) return;
        var v = d.variant;
        if (!v || !v.id) return;
        currentPickerVariantId = String(v.id);
        tiers.forEach(function (t) {
          var mapAttr = t.getAttribute('data-price-map');
          if (!mapAttr) return;
          var map;
          try { map = JSON.parse(mapAttr); } catch (err) { return; }
          var p = map[String(v.id)];
          if (!p) return;
          t.setAttribute('data-price', p);
          var priceEl = t.querySelector('.g-tier__price');
          if (priceEl) priceEl.textContent = p;
        });
        var sel = group.querySelector('.g-tier.is-selected') || tiers[0];
        if (sel) select(sel);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-griptec-tiers]').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after Shopify section renders (theme editor / variant swaps).
  document.addEventListener('shopify:section:load', initAll);
})();
